import React from 'react';

const Footer = () => {
  return (
    <div id='displayContact' className='text'>
      <a href='https://www.orjon.com'>orjon.com</a>
    </div>
  );
};

export default Footer;
